<template>
  <div class="countdown">
    <!-- Countdown content goes here -->
    <ul class="timer">
      <li><strong>{{ subscription.days }}</strong><span>{{ $config.common.timer.days }}</span></li>
      <li class="sep" />
      <li><strong>{{ subscription.hours }}</strong><span>{{ $config.common.timer.hours }}</span></li>
      <li class="sep" />
      <li><strong>{{ subscription.minutes }}</strong><span>{{ $config.common.timer.minutes }}</span></li>
    </ul>
    <div>{{ legals }}</div>
  </div>
</template>
<script>
import TimerMixin from '@/mixins/TimerMixin.vue';
import { DateTime } from 'luxon';

export default {
  name: 'ProductCountDown',
  mixins: [TimerMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    legals() {
      // pour acquérir votre monnaie à sa valeur faciale. À partir du XX mars, son prix sera de 1 XXX € .
      const launchDate = this.product.subscription?.endDate;
      const params = {
        date: DateTime.fromISO(launchDate).toLocaleString(DateTime.DATE_FULL, { locale: this.$lang }),
        sellPrice: this.product.sellPrice,
      };
      return this.$config.common.legals.format(params);
    },
  },
  methods: {
  },
};
</script>
<style lang="stylus" scoped>
.countdown {
  border-radius: 10px;
  color: var(--inverted-text-color);
  font-size: 13px;
  padding: 15px;
  line-height: 1.4;

  .timer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    list-style: none;
    margin: 0;
    margin-bottom: 8px;

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0;
      width: fit-content;

      strong {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.1;
      }

      &.sep {
        width: 1px;
        height: 16px;
        background-color: var(--main-color);
        opacity: 40%;
      }
    }
  }
}
</style>
<style scoped>
.countdown {
  background-color: color-mix(in srgb, var(--main-color) 10%, transparent);
}
</style>
